const isProd = process.env.NODE_ENV !== 'development';
export const AUTH_REDIRECT_SIGN_IN = isProd ? process.env.REACT_APP_AUTH_SIGN_IN : 'https://localhost:3000/login';
export const AUTH_REDIRECT_SIGN_OUT = isProd ? process.env.REACT_APP_AUTH_SIGN_OUT : 'https://localhost:3000/logout';

export const APP_NAME = 'Inference';
export const APP_ISSUER = 'Heimdal Satellite Technologies';
